
// import { configureStore } from "@reduxjs/toolkit";
// import userReducer from "./slices/userSlice";
// import storeReducer from "./slices/storeSlice"; 
// import transactionTypeReducer from "./slices/transactionTypeSlice";
// import cashRegisterReducer from "./slices/cashRegisterSlice";
// import customFieldReducer from "./slices/customFieldSlice";
// import aclReducer from "./slices/aclSlice";
// import printConfigReducer from "./slices/printConfigSlice"; 
// import reportConfigReducer from "./slices/reportConfigSlice";
// import storeLocationsReducer from "./slices/storeLocationSlice";

// const LOCAL_STORAGE_KEY = "reduxState";

// // Load persisted state from localStorage
// const loadStateFromLocalStorage = () => {
//   try {
//     const serializedState = localStorage.getItem(LOCAL_STORAGE_KEY);
//     if (!serializedState) return undefined;
//     return JSON.parse(serializedState);
//   } catch (e) {
//     console.error("Error loading state from localStorage", e);
//     return undefined;
//   }
// };

// // Save state to localStorage
// const saveStateToLocalStorage = (state) => {
//   try {
//     const serializedState = JSON.stringify(state);
//     localStorage.setItem(LOCAL_STORAGE_KEY, serializedState);
//   } catch (e) {
//     console.error("Error saving state to localStorage", e);
//   }
// };

// const persistedState = loadStateFromLocalStorage();

// export const store = configureStore({
//   reducer: {
//     user: userReducer,
//     store: storeReducer,
//     transactionType: transactionTypeReducer,
//     cashRegister: cashRegisterReducer,
//     customFields: customFieldReducer,
//     acl: aclReducer,
//     printConfig: printConfigReducer,
//     reportConfig: reportConfigReducer,
//     storeLocations:storeLocationsReducer
//   },
//   preloadedState: persistedState, // Load saved state
// });

// // Subscribe to store changes and save to localStorage automatically
// store.subscribe(() => {
//   saveStateToLocalStorage(store.getState());
// });


import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import storeReducer from "./slices/storeSlice"; 
import transactionTypeReducer from "./slices/transactionTypeSlice";
import cashRegisterReducer from "./slices/cashRegisterSlice";
import customFieldReducer from "./slices/customFieldSlice";
import aclReducer from "./slices/aclSlice";
import printConfigReducer from "./slices/printConfigSlice"; 
import reportConfigReducer from "./slices/reportConfigSlice";
import storeLocationsReducer from "./slices/storeLocationSlice";
import filterReducer from "./slices/filterSlice";

import { 
  loadStateFromLocalStorage, 
  saveStateToLocalStorage,
  initializeStorageCheck
} from "../util/localStorageUtils";

// Initialize storage check on store setup
initializeStorageCheck();

const persistedState = loadStateFromLocalStorage();

export const store = configureStore({
  reducer: {
    user: userReducer,
    store: storeReducer,
    transactionType: transactionTypeReducer,
    cashRegister: cashRegisterReducer,
    customFields: customFieldReducer,
    acl: aclReducer,
    printConfig: printConfigReducer,
    reportConfig: reportConfigReducer,
    storeLocations: storeLocationsReducer,
    filter:filterReducer
  },
  preloadedState: persistedState,
});

// Subscribe to store changes and save to localStorage automatically
store.subscribe(() => {
  saveStateToLocalStorage(store.getState());
});

export default store;

